export const getEventPath = (e: Event): EventTarget[] => {
  // modern browsers
  if ('composedPath' in e) {
    return (e as any).composedPath()
  }

  // fallback: build path manually
  const path: EventTarget[] = []
  let node: Node | null = (e as any).target as Node | null

  while (node) {
    path.push(node)
    node = (node as HTMLElement).parentNode
  }
  path.push(document, window)

  return path
}
